<template>
  <span v-html="salesPartnersText"></span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { getTld } from "@/utils/urlHelper.ts";
import { useCompanyStore } from "@/store/company.ts";

defineOptions({
  name: "footer-sales-partners-text",
});

const { t } = useI18n();
const companyStore = useCompanyStore();

const salesPartnersText = computed(() => {
  const isComOrNet = ["com", "net"].includes(getTld());

  const epochLink = "<a href='https://www.epoch.com'  target='_blank' rel='nofollow'>Epoch.com</a>";
  const ccbillLink = "<a href='https://support.ccbill.com/' target='_blank' rel='nofollow'>CCBill.com</a>";
  const segpayLink = "<a href='https://cs.segpay.com' target='_blank' rel='nofollow'>Segpayeu.com</a>";

  if (companyStore.isEEI) {
    if (isComOrNet) {
      return t("Please visit [anotherPartner] and [epoch], our authorized payment processors.")
        .replace("[anotherPartner]", ccbillLink)
        .replace("[epoch]", epochLink);
    }

    return t("Please visit [epoch], our authorized payment processor.").replace("[epoch]", epochLink);
  }

  if (isComOrNet) {
    return t("Please visit [ccbill], [segpay] and [epoch], our authorized payment processors.")
      .replace("[ccbill]", ccbillLink)
      .replace("[segpay]", segpayLink)
      .replace("[epoch]", epochLink);
  }

  return t("Please visit [anotherPartner] and [epoch], our authorized payment processors.")
    .replace("[anotherPartner]", segpayLink)
    .replace("[epoch]", epochLink);
});
</script>
